function removeOrphanOverlayBackdrops() {
  document.querySelectorAll(".hs-overlay-backdrop").forEach((el) => {
    const overlayId = (el.id || "").replace(/-backdrop$/, "")
    const overlay = overlayId ? document.getElementById(overlayId) : null
    if (!overlay || (overlay.classList.contains("hidden") && !overlay.classList.contains("open"))) {
      el.remove()
    }
  })
}

let prelinePromise = null

function loadPreline() {
  if (!prelinePromise) {
    prelinePromise = import("preline")
  }
  return prelinePromise
}

function initPreline() {
  loadPreline()
    .then(() => {
      try {
        if (window.HSStaticMethods?.autoInit) {
          window.HSStaticMethods.autoInit()
        }
      } catch (_) {
        // Safari antigo: falha no Preline não pode impedir o restante da UI.
      }
      removeOrphanOverlayBackdrops()
    })
    .catch(() => {
      removeOrphanOverlayBackdrops()
    })
}

function scheduleInitPreline() {
  if (document.readyState === "complete") {
    initPreline()
    return
  }
  window.addEventListener("load", initPreline, { once: true })
}

function cleanupPreline() {
  try {
    if (window.HSStaticMethods?.cleanCollection) {
      window.HSStaticMethods.cleanCollection()
    }
  } catch (_) {}
  removeOrphanOverlayBackdrops()
}

let streamInitTimer = null

function scheduleInitPrelineFromStream() {
  if (streamInitTimer != null) return
  streamInitTimer = window.setTimeout(() => {
    streamInitTimer = null
    scheduleInitPreline()
  }, 120)
}

document.addEventListener("turbo:load", scheduleInitPreline)
document.addEventListener("turbo:render", scheduleInitPreline)
document.addEventListener("turbo:morph", scheduleInitPreline)
document.addEventListener("turbo:before-stream-render", (event) => {
  const render = event.detail.render
  event.detail.render = (streamElement) => {
    render(streamElement)
    const target = streamElement?.getAttribute?.("target") || ""
    if (target.startsWith("whatsapp_")) return
    scheduleInitPrelineFromStream()
  }
})
document.addEventListener("turbo:before-cache", cleanupPreline)
document.addEventListener("turbo:before-cache", () => {
  document.querySelectorAll("turbo-frame#whatsapp_inbox_panel").forEach((frame) => {
    const skeleton = document.getElementById("whatsapp_inbox_panel_skeleton")
    if (skeleton?.content) {
      frame.replaceChildren(skeleton.content.cloneNode(true))
    } else {
      frame.replaceChildren()
    }
    frame.removeAttribute("src")
    frame.removeAttribute("complete")
  })
})

export { initPreline, cleanupPreline, removeOrphanOverlayBackdrops }
